import React from 'react';
import { X } from 'react-feather';
import IconButton from 'ui/IconButton';
import { MATCHING } from 'constants/config';
import MatchingTextField from './MatchingTextField';

export const ItemTypes = {
  CHOICE: 'choice',
};

const MatchingPairRow = ({
  choice,
  onUpdate,
  onDelete,
  loading,
  addChoice,
  disableAddItem,
  isDuplicate,
}) => {
  const { position } = choice;

  return (
    <div className="MatchingRowContainer d-f fd-r jc-s ai-c ">
      <MatchingTextField
        className="Matching-Input"
        whiteBackground
        disabled={loading}
        placeholder={t('questions.choices.matching.item')}
        value={choice.item}
        name={t('questions.choices.matching.item')}
        onChange={e =>
          onUpdate({
            ...choice,
            item: e.target.value,
          })
        }
        aria-label={t('questions.choices.matching.item')}
        maxLength={MATCHING.MAX_CHARACTERS}
        isDuplicate={isDuplicate}
      />
      <MatchingTextField
        className="Matching-Input"
        whiteBackground
        disabled={loading}
        placeholder={t('questions.choices.matching.match')}
        value={choice.match}
        name={t('questions.choices.matching.match')}
        onChange={e =>
          onUpdate({
            ...choice,
            match: e.target.value,
          })
        }
        aria-label="Matching Input Box"
        maxLength={MATCHING.MAX_CHARACTERS}
        onKeyDown={e => {
          if ((e.keyCode === 13 || e.key === 'Enter') && !disableAddItem) {
            addChoice();
          }
        }}
      />
      <IconButton
        tooltip={t('common.remove')}
        type="button"
        onClick={() => onDelete(choice)}
        disabled={loading}
        aria-label={`${t('common.remove')} ${position}`}
      >
        <X size={32} />
      </IconButton>
    </div>
  );
};

export default MatchingPairRow;
